import React from "react";
import { Form } from "@components";
import { useDispatch, useSelector } from "react-redux";
import { State, getUserSettings, updateUserSettings } from "@store";

export const Settings: React.FC = () => {
  const storeDispatch = useDispatch();
  const [updating, setUpdating] = React.useState(false);
  const [settings, fetching, error] = useSelector((state: State) => {
    return [
      state.user_settings,
      state.network.fetching.user_settings,
      state.network.error.user_settings,
    ];
  });

  React.useEffect(() => {
    if (!settings && !fetching && !error) {
      storeDispatch(getUserSettings());
    }
  }, [settings, fetching, error, storeDispatch]);

  return (
    <Form.Checkbox
      disabled={!settings || updating}
      label="I would like to receive Chatbot notifications"
      name="sendChatAlert"
      onChange={(name, value) => {
        setUpdating(true);
        Promise.resolve(
          storeDispatch(
            updateUserSettings({
              ...settings,
              sendChatAlert: value,
            })
          )
        ).then(() => setUpdating(false));
      }}
      size={12}
      value={settings ? settings.sendChatAlert : false}
    />
  );
};
